import {MMQueryOptions} from 'lionheartland';


export class SODeleteAppliedConstraint {

  constructor(
    public uid: string,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
}
